export const ROLE = {
  SUPPER_ADMIN: 'SUPPER_ADMIN',
  ADMIN: 'ADMIN',
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER',
  MENTOR: 'MENTOR',
}

// Mentor <-> coach assignment errors. USER-197 is only reachable by calling the
// API directly: the coach picker already hides coaches owned by another mentor.
export const ASSIGN_COACH_ERROR_CODE = {
  COACH_IDS_INVALID: 'MFS-E-LEARNING-ADMIN-USER-196',
  COACH_ALREADY_HAS_MENTOR: 'MFS-E-LEARNING-ADMIN-USER-197',
  MENTOR_INVALID: 'MFS-E-LEARNING-ADMIN-USER-199',
}

export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

export const MENU_KEY = {
  MEMBERS: 'MEMBERS',
  FUNCTIONS: 'FUNCTIONS',
  PAYMENTS: 'PAYMENTS',
  SETTING: 'SETTING',
}

export const SUB_MENU_KEY = {
  MEMBERS: 'MEMBERS',
  FUNCTIONS: 'FUNCTIONS',
  PAYMENTS: 'PAYMENTS',
  SETTING: 'SETTING',
}

export const ACTION_TYPE = {
  APPROVE: 'approve',
  REJECT: 'reject',
}

export const STAGE_GRADUATION_STATUS = {
  FREE: 'free',
  PAID: 'paid',
  TRIAL: 'trial',
}

export const SUBSCRIPTION_PAYMENT_STATUS = {
  CURRENT: 'current',
  SUSPENDED: 'suspended',
  CANCELED: 'canceled',
}

export const PAYMENT_STATUS = {
  FREE: 'free',
  PAID: 'paid',
}

export const INACTIVE_REASON = {
  UNIVAPAY_CANCEL_PAYMENT: 'univapay_cancel_payment',
  DELETE_ACCOUNT: 'delete_account',
  PAYMENT_FAILED: 'payment_failed',
}
